module.exports = __webpack_public_path__ + "img/no_other.db0c2da1.png";